import { useCopilotTool } from '@customerio/hydra-copilot/react';
import { cache, type InvalidateCacheEntry } from '@customerio/hydra-nav-state';
import { analyzeBashCommand, getMutatingResources, type CurlResource } from '../approval/parse-curl-resources';

// Build an invalidation entry from a parsed curl resource. Optional fields are
// only included when present so consumers don't see explicit `undefined`s.
//  - id: omitted for creates (POST /collection) — the new id is in the
//    response body, not the URL. Consumers treat a missing id as "the whole
//    collection of this type changed."
//  - parentType / parentId: set only for nested URLs like
//    `.../campaigns/123/notes`, so consumers can scope the refresh to the
//    relevant parent (e.g. "only when viewing campaign 123").
function entryFromResource(resource: CurlResource): InvalidateCacheEntry {
  const entry: InvalidateCacheEntry = { type: resource.resourceType };
  if (resource.resourceId != null) {
    entry.id = resource.resourceId;
  }
  if (resource.parentType != null && resource.parentId != null) {
    entry.parentType = resource.parentType;
    entry.parentId = resource.parentId;
  }
  return entry;
}

export async function invalidateCacheForCommand(command: string) {
  const analysis = await analyzeBashCommand(command);
  const mutating = getMutatingResources(analysis.resources);

  if (mutating.length === 0) {
    return;
  }

  const entries = mutating.filter((resource) => resource.fullyResolved).map(entryFromResource);

  if (entries.length > 0) {
    cache.invalidate(entries);
  }
}

export function BashTool() {
  useCopilotTool({
    type: 'server',
    name: 'bash',
    handler({ args, response, wasApproved }) {
      if (response?.error != null) {
        return;
      }

      if (wasApproved !== true) {
        return;
      }

      void invalidateCacheForCommand(String(args.command));
    },
  });

  return null;
}
